import VideoCardSmall from "./VideoCardSmallOld";

export default function VideoCardSmallCollection(props) {
  return (
    <div className="flex flex-row items-center">
      <div className="flex flex-col flex-initial flex-grow-0 mx-auto  ">
        <div className="inline-flex flex-row flex-auto flex-wrap gap-3 justify-center">
          {props.projects.map((p) => {
            let link = "/" + p.projectid;
            return <VideoCardSmall {...p} key={p.projectid} />;
          })}
          <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
          <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
          <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
          <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
          <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
          <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
          <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
        </div>
      </div>
    </div>
  );
}
